import React, { useEffect, useState } from "react";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import {
  Typography,
  DatePicker,
  Modal,
  Table,
  Form,
  TreeSelect,
  Row,
  Col,
  Input,
  InputNumber,
  Badge,
  Tag,
  Popconfirm,
  Radio,
} from "antd";
import { errorHandle, openNotificationWithIcon } from "../../Function";
import moment from "moment";
import { ListBoPhanApi } from "../../../api/getListTeam";
import {
  dieuChinhPhepCaNhanApi,
  duyetPhepTeamApi,
  KhaiBaoPhepApi,
  ListBangPhepNSApi,
  ResultLeaveDaysApi
} from "../../../api/getListBangPhep";
import { DotChartOutlined, DownloadOutlined, EditOutlined, LineChartOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { ListMemberOfTeamApi } from "../../../api/getTeamMember";
import fnFileDownload from "js-file-download";

const { Text, Link } = Typography;
const validateMessages = {
  required: "${label} là bắt buộc.",
  types: {},
  number: {},
};

const ModalKhaiBaoPhep = ({
  visible,
  onCancel,
  updateData,
  currentSelectedDate,
  lsMember,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState([]);
  const [treeDataUser, setTreeDataUser] = useState([]);

  useEffect(() => {
    const treeDataTemp = lsMember.map((item) => {
      return { title: item.username, value: item.id, key: item.id };
    });
    setTreeDataUser(treeDataTemp);
  }, [visible]);

  const onFinish = (values) => {
    KhaiBaoPhepApi({
      listUser: JSON.stringify(values.username),
      nam: moment(currentSelectedDate).year(),
      // phepcu: values.phepcu,
      thamnien: values.thamnien,
      phepnam: values.phepnam,
      // thoiGian: values.date.format("YYYYMM"),
      // dieuchinh: values.edit,
      // ghichu: values.note
    })
      .then((r) => {
        form.resetFields();
        updateData();
        openNotificationWithIcon("success", "Thành công", "");
        onCancel();
      })
      .catch((err) => {
        errorHandle(err);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onCancelModal = () => {
    form.resetFields();
    setCurrentUser([]);
    updateData();
    onCancel();
  };

  const onChangeUser = (value) => {
    if (value.length > 0) {
      setCurrentUser(value);
    }
  };

  const tPropsConfig = {
    treeData: [
      {
        title:
          currentUser.length > 0 ? (
            <span
              onClick={() => {
                setCurrentUser([]);
                form.setFieldsValue({ username: [] });
                onChangeUser([]);
              }}
              className="style_SelectTeam"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                setCurrentUser(lsMember.map((item) => item.id));
                form.setFieldsValue({
                  username: lsMember.map((item) => item.id),
                });
                onChangeUser(lsMember.map((item) => item.id));
              }}
              className="style_SelectTeam"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeDataUser,
    ],
    value: currentUser,
    onChange: onChangeUser,
    treeCheckable: true,
    // showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 2,
    placeholder: "Chọn nhân viên",
    style: { width: "fit-content", minWidth: 200 },
  };

  return (
    <Modal
      title={"Khai báo phép"}
      visible={visible}
      onCancel={onCancelModal}
      footer={false}
    >
      <Form
        form={form}
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        validateMessages={validateMessages}
      >
        <Row>
          <Col span={24}>
            <Form.Item label="Nhân viên" name="username">
              <TreeSelect {...tPropsConfig} />
            </Form.Item>
          </Col>
          {/* <Col span={24}>
                        <Form.Item
                            label="Phép cũ"
                            name="phepcu"
                            rules={[{ required: true }]}
                        >
                            <InputNumber min={0} max={30} maxLength={3} style={{width: "100%"}}/>
                        </Form.Item>
                    </Col> */}
          <Col span={24}>
            <Form.Item
              label="Thâm niên"
              name="thamnien"
              rules={[{ required: true }]}
            >
              <InputNumber
                min={0}
                max={50}
                maxLength={2}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Phép năm"
              name="phepnam"
              rules={[{ required: true }]}
            >
              <InputNumber
                min={0}
                max={12}
                maxLength={2}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          {/*<Col span={24}>*/}
          {/*    <Form.Item*/}
          {/*        label="Ghi chú"*/}
          {/*        name="note"*/}
          {/*        rules={[{ required: true }]}*/}
          {/*    >*/}
          {/*        <Input maxLength={300}/>*/}
          {/*    </Form.Item>*/}
          {/*</Col>*/}
        </Row>

        <Row gutter={16}>
          <Col offset={9}>
            <Form.Item>
              <Button
                type="success"
                htmlType="submit"
                className={"m-2"}
                disabled={loading}
              >
                Thêm
              </Button>
              <Button onClick={onCancelModal}>Thoát</Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

function disabledMonth(current) {
  // Can not select days after today and today
  const currentDate = new Date();
  return (
    current &&
    current >
    moment(
      new Date(currentDate.getFullYear(), currentDate.getMonth()),
      0
    ).endOf("day")
  );
}

const ModalEditPhep = ({ visible, onCancel, updateData, dataDetailPhep }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    form.resetFields();
    if (visible) {
      form.setFieldsValue({
        date: moment(dataDetailPhep.strMonth, "MMYYYY"),
        edit: dataDetailPhep["dieuchinh" + dataDetailPhep.strMonth],
        note: dataDetailPhep.ghichu,
      });
    }
  }, [visible]);

  const onFinish = (values) => {
    dieuChinhPhepCaNhanApi({
      // UserId: dataDetailPhep.userId,
      id: dataDetailPhep["id" + dataDetailPhep.strMonth],
      dieuchinh: values.edit,
      ghichu: values.note,
    })
      .then((r) => {
        updateData();
        openNotificationWithIcon("success", "Thành công", "");
        onCancel();
      })
      .catch((err) => {
        errorHandle(err);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Modal
      title={"Điều chỉnh ngày phép"}
      visible={visible}
      onCancel={onCancel}
      footer={false}
      width={800}
    >
      <Form
        form={form}
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        validateMessages={validateMessages}
      >
        <Row>
          <Col span={24}>
            <Form.Item label="Tên nhân viên" name="username">
              <Text strong>{dataDetailPhep.username}</Text>
            </Form.Item>
          </Col>
          <Col span={9}>
            <Form.Item
              label="Thời gian"
              name="date"
              rules={[{ required: true }]}
            >
              <DatePicker format={"MM/YYYY"} allowClear={false} disabled />
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item
              label="Điều chỉnh"
              name="edit"
              rules={[{ required: true }]}
            >
              <Input maxLength={100} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Ghi chú" name="note" rules={[{ required: true }]}>
              <Input maxLength={300} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col offset={9}>
            <Form.Item>
              <Button
                type="success"
                htmlType="submit"
                className={"m-2"}
                disabled={loading}
              >
                Thêm
              </Button>
              <Button onClick={onCancel}>Thoát</Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

// const ModalEditPhepNam =({visible, onCancel, updateData, currentSelectedDate, dataDetailPhep, lsMember})=>{
//     const [form] = Form.useForm();
//     const [loading, setLoading] = useState(false);
//     useEffect(()=>{
//         form.resetFields();
//         if (visible) {
//             form.setFieldsValue({
//                 phepcu: dataDetailPhep.phepcu,
//                 thamnien: dataDetailPhep.thamnien,
//                 phepnam: dataDetailPhep.phepnam
//             });

//         };
//     },[visible]);

//     const onFinish = (values) => {
//         EditPhepNamApi({
//             userId : dataDetailPhep.userId,
//             nam: moment(currentSelectedDate).year(),
//             phepcu: values.phepcu,
//             thamnien: values.thamnien,
//             phepnam: values.phepnam,
//         })
//         .then(r=>{
//             form.resetFields();
//             updateData();
//             openNotificationWithIcon('success','Thành công','')
//             onCancel();
//         })
//         .catch(err=>{
//             errorHandle(err)
//         })
//     };

//     const onFinishFailed = (errorInfo) => {
//         console.log('Failed:', errorInfo);
//     };

//     return (
//         visible && <Modal title={`Bảng phép năm ${moment(currentSelectedDate).year()}  -  ${lsMember.filter(item => item.id == dataDetailPhep.userId)[0]['teamName']} `}
//             visible={visible} onCancel={onCancel} footer={false}>
//             <Form
//                 form={form}
//                 name="basic"
//                 onFinish={onFinish}
//                 onFinishFailed={onFinishFailed}
//                 autoComplete="off"
//                 validateMessages={validateMessages}
//             >
//                 <Row >
//                     <Col span={24}>
//                         <Form.Item
//                             label="Tên nhân viên"
//                             name="username"
//                         >
//                             <Text strong>{dataDetailPhep.username}</Text>
//                         </Form.Item>
//                     </Col>
//                     <Col span={24}>
//                         <Form.Item
//                             label="Phép cũ"
//                             name="phepcu"
//                             rules={[{ required: true }]}
//                         >
//                             <InputNumber min={0} max={30} maxLength={3} style={{width: "100%"}}/>
//                         </Form.Item>
//                     </Col>
//                     <Col span={24}>
//                         <Form.Item
//                             label="Thâm niên"
//                             name="thamnien"
//                             rules={[{ required: true }]}
//                         >
//                             <InputNumber min={0} max={50} maxLength={2} style={{width: "100%"}}/>
//                         </Form.Item>
//                     </Col>
//                     <Col span={24}>
//                         <Form.Item
//                             label="Phép năm"
//                             name="phepnam"
//                             rules={[{ required: true }]}
//                         >
//                             <InputNumber min={0} max={12} maxLength={2} style={{width: "100%"}}/>
//                         </Form.Item>
//                     </Col>
//                 </Row>

//                 <Row gutter={16}>
//                     <Col offset={9}>
//                         <Form.Item >
//                             <Button type="success" htmlType="submit" className={'m-2'} disabled={loading}>Thêm</Button>
//                             <Button onClick={onCancel}>Thoát</Button>
//                         </Form.Item>
//                     </Col>
//                 </Row>
//             </Form>
//         </Modal>
//     )
// }

export const BangPhep = () => {
  const defaultPageSize = 50;
  const [pager, setPager] = useState({
    pageSize: defaultPageSize,
    count: 0,
    current: 1,
  });
  const [data, setData] = useState([]);
  const [lsTeam, setLsTeam] = useState([]);
  const [columnFinal, setColumnFinal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [treeData, setTreeData] = useState([]);
  const [currentTeam, setCurrentTeam] = useState([]);
  const [currentSelectedDate, setCurrentSelectedDate] = useState(
    moment(new Date())
  );
  const [isShowEditPhep, setIsShowEditPhep] = useState(false);
  const [isShowKhaiBaoPhep, setIsShowKhaiBaoPhep] = useState(false);
  const [dataDetailPhep, setDataDetailPhep] = useState([]);
  const userInfo = useSelector((state) => state.getUserInfo.userInfo);
  const [lsMemberAll, setLsMemberAll] = useState([]);
  const [lsMember, setLsMember] = useState([]);
  // const [isShowEditPhepNam, setIsShowEditPhepNam] = useState(false);
  const [typeExport, setTypeExport] = useState("month")
  const [lsBoPhan, setLsBoPhan] = useState([]);
  const [currentBoPhan, setCurrentBoPhan] = useState([]);
  const [treeDataBoPhan, setTreeDataBoPhan] = useState([]);
  const [lsAllTeam, setLsAllTeam] = useState([]);

  const columns_first = (date) => {
    return [
      // {
      //     title: "STT",
      //     dataIndex: "index",
      //     key: "index",
      //     render: (value, item, index) => ((pager.current || 1) - 1) * pager.pageSize + index + 1,
      //     sortDirections: ['descend', 'ascend', 'descend'],
      // },
      {
        title: "Nhân viên",
        dataIndex: "username",
        key: "username",
        align: "center",
        className: "highlight",
        filterKey: "username",
        type: "text",
        width: 160,
        canSearch: true,
      },
      {
        title:
          "Phép cũ " +
          moment(new Date(date)).subtract(1, "year").format("YYYY"),
        dataIndex: "phepcu",
        key: "phepcu",
        align: "center",
        filterKey: "phepcu",
        className: "highlight",
        type: "text",
        width: 80,
        canSearch: true,
        render: (text, record) => {
          if (text != null) {
            if (text.toString().length == 1) {
              return text.toFixed(1);
            }
            return text;
          }
        },
        // render:(text, record) => handleCellEditPhepNam(text, record, 'phepcu', setIsShowEditPhepNam, setDataDetailPhep)
      },
      {
        title: "Thâm niên",
        dataIndex: "thamnien",
        key: "thamnien",
        align: "center",
        className: "highlight",
        width: 80,
        filterKey: "thamnien",
        type: "text",
        canSearch: true,
        // render:(text, record) =>handleCellEditPhepNam(text, record, 'thamnien', setIsShowEditPhepNam, setDataDetailPhep)
        render: (text, record) => {
          if (text != null) {
            if (text.toString().length == 1) {
              return text.toFixed(1);
            }
            return text;
          }
        },
      },
      {
        title: "Phép năm",
        dataIndex: "phepnam",
        key: "phepnam",
        align: "center",
        width: 80,
        className: "highlight",
        filterKey: "phepnam",
        type: "text",
        canSearch: true,
        render: (text, record) => {
          if (text != null) {
            if (text.toString().length == 1) {
              return text.toFixed(1);
            }
            return text;
          }
        },
        // onCell: (record) => ({
        //     record,
        //     editable: col.editable,
        //     dataIndex: col.dataIndex,
        //     title: col.title,
        //     handleSave,
        //   }),
        // render:(text, record) => handleCellEditPhepNam(text, record, setIsShowEditPhepNam, setDataDetailPhep)
        // render:(text, record) => handleCellEditPhepNam(text, record, 'phepnam', setIsShowEditPhepNam, setDataDetailPhep)
      },
    ];
  };

  const columns_last = [
    {
      title: "Ghi chú",
      dataIndex: "ghichu",
      key: "ghichu",
      align: "center",
      filterKey: "ghichu",
      type: "text",
      className: "highlight",
      width: 300,
      canSearch: true,
      // ellipsis: true
    },
    {
      title: "Trạng thái",
      dataIndex: "trangthai",
      key: "trangthai",
      className: "lastColumn highlight",
      align: "center",
      filterKey: "trangthai",
      type: "text",
      width: 100,
      canSearch: true,
      render: (text, record) => {
        if (record["statusid" + currentSelectedDate.format("MMYYYY")] == 0) {
          return (
            <Tag
              color="#FFFBE6"
              key={0}
              style={{
                color: "#FBB458",
                fontWeight: "600",
                borderRadius: 10,
                border: `1px solid #FBB458`,
              }}
            >
              {text}
            </Tag>
          );
        } else {
          return (
            <Tag
              color="#F6FFED"
              key={1}
              style={{
                color: "#77C9A3",
                fontWeight: "600",
                borderRadius: 10,
                border: `1px solid #77C9A3`,
              }}
            >
              {text}
            </Tag>
          );
        }
      },
    },
  ];

  // const handleCellEditPhepNam = (text, record, setIsShowEditPhepNam, setDataDetailPhep) => {
  //     const onAddDetailItem = () => {
  //         setDataDetailPhep(record)
  //         setIsShowEditPhepNam(true)
  //     }
  //     return (
  //         <>
  //             <div style={{textAlign:'center',width:'100%', cursor: "pointer"}} onClick={onAddDetailItem}>
  //             {text} <EditOutlined />
  //             </div>
  //         </>
  //     )
  // };

  const handleCellDieuChinh = (
    text,
    record,
    strMonth,
    setIsShowEditPhep,
    setDataDetailPhep
  ) => {
    const onAddDetailItem = () => {
      setDataDetailPhep(record);
      setIsShowEditPhep(true);
    };
    if (text != null) {
      if (text.toString().length == 1) {
        text = text.toFixed(1);
      }
    }

    if (record["statusid" + strMonth] == 0) {
      record["strMonth"] = strMonth;
      return (
        <>
          <div style={{ textAlign: "center", width: "100%" }}>
            {text} <EditOutlined onClick={onAddDetailItem} />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div style={{ textAlign: "center", width: "100%" }}>{text}</div>
        </>
      );
    }
  };

  const columnsMonth = (date) => {
    const lsMonth = [
      moment(new Date(date)).subtract(1, "month").format("MM/YYYY"),
      date.format("MM/YYYY"),
    ];
    let result = [];
    for (let month of lsMonth) {
      let obj = {};
      obj.title = month;
      const strMonth = month.replace("/", "");
      obj.children = [
        {
          title: "Cấp",
          dataIndex: "cap" + strMonth,
          key: "cap" + strMonth,
          className: "hoverBlur",
          align: "center",
          filterKey: "cap" + strMonth,
          type: "text",
          width: 80,
          render: (text, record) => {
            if (text != null) {
              if (text.toString().length == 1) {
                return text.toFixed(1);
              }
              return text;
            }
          },
        },
        {
          title: "Dùng",
          dataIndex: "dung" + strMonth,
          key: "dung" + strMonth,
          className: "hoverBlur",
          align: "center",
          filterKey: "dung" + strMonth,
          type: "text",
          width: 80,
          render: (text, record) => {
            if (text != null) {
              if (text.toString().length == 1) {
                return text.toFixed(1);
              }
              return text;
            }
          },
        },
        {
          title: "Điều chỉnh",
          dataIndex: "dieuchinh" + strMonth,
          key: "dieuchinh" + strMonth,
          className: "hoverBlur",
          align: "center",
          filterKey: "dieuchinh" + strMonth,
          type: "text",
          width: 90,
          render: (text, record) => {
            if (month !== lsMonth[1]) {
              if (text != null) {
                if (text.toString().length == 1) {
                  return text.toFixed(1);
                }
                return text;
              }
            }
            return handleCellDieuChinh(
              text,
              record,
              strMonth,
              setIsShowEditPhep,
              setDataDetailPhep
            );
          },
        },
        {
          title: "Còn lại",
          dataIndex: "conlai" + strMonth,
          key: "conlai" + strMonth,
          align: "center",
          className: "hoverBlur",
          filterKey: "conlai" + strMonth,
          type: "text",
          width: 80,
          render: (text, record) => {
            if (text != null) {
              if (text.toString().length == 1) {
                return text.toFixed(1);
              }
              return text;
            }
          },
        },
      ];
      result.push(obj);
    }
    return result;
  };

  const mapData = (values, date) => {
    let arrData = [];
    for (let iUser of values) {
      let obj = {};
      obj.username = iUser.msnv + "-" + iUser.username;
      obj.userId = iUser.userId;
      obj.phepcu = iUser.phepcu;
      obj.thamnien = iUser.thamnien;
      obj.phepnam = iUser.phepnam;
      for (let i of iUser.data) {
        obj["cap" + i.thang] = i.cap;
        obj["dung" + i.thang] = i.dung;
        obj["dieuchinh" + i.thang] = i.dieuchinh;
        obj["conlai" + i.thang] = i.conlai;
        obj["statusid" + i.thang] = i.TrangthaiId;
        obj["id" + i.thang] = i.id;
        obj["trangthai" + i.thang] = i.trangthai;
        if (i.thang === date.format("MMYYYY")) {
          obj.trangthai = i.trangthai;
          obj.ghichu = i.ghichu;
        }
      }
      arrData.push(obj);
    }
    return arrData;
  };

  // useEffect(()=>{
  //     if (currentSelectedDate && currentTeam.length > 0){
  //         fetchData({
  //             idTeam:JSON.stringify(currentTeam),
  //             thoiGian:currentSelectedDate.format("YYYYMM"),
  //             ...pager
  //         });
  //     }

  // },[currentTeam])

  const fetchData = (params = {}) => {
    setLoading(true);
    ListBangPhepNSApi({
      idTeam: params.idTeam,
      thoiGian: params.thoiGian,
      page: params.current,
      page_size: params.pageSize,
      search: params.search,
    }).then((r) => {
      setData(mapData(r.data.results, params.date || currentSelectedDate));
      setColumnFinal([
        ...columns_first(params.date || currentSelectedDate),
        ...columnsMonth(params.date || currentSelectedDate),
        ...columns_last,
      ]);
      setPager({
        current: params.current,
        pageSize: params.pageSize,
        count: r.data.count,
      });
      setLoading(false);
    });
  };

  useEffect(() => {
    // if (currentTeam.length > 0) {
    //     fetchData({
    //         idTeam:JSON.stringify(currentTeam),
    //         thoiGian:moment(currentSelectedDate).format("YYYYMM"),
    //         ...pager
    //     })
    //     setLsMember(lsMemberAll.filter(x => currentTeam.includes(x.teamId)));

    // } else {
    //     setData([]);
    //     setLsMember([]);
    // }
    if (currentSelectedDate && currentTeam.length > 0) {
      fetchData({
        date: currentSelectedDate,
        idTeam: JSON.stringify(currentTeam),
        thoiGian: currentSelectedDate.format("YYYYMM"),
        ...pager,
      });
      setLsMember(lsMemberAll.filter((x) => currentTeam.includes(x.teamId)));
    }
    if (currentTeam.length === 0) {
      setData([]);
      setLsMember([]);
    }
  }, [currentSelectedDate, currentTeam]);

  const fetchListTeam = () => {
    ListBoPhanApi().then((res) => {
      const arrTeam = userInfo.team_permissions
        .filter((item) => item.phanquyen__ten_pq === "leave_dashboard_ns")
        .map((item, index) => {
          const idBoPhanForTeam = res.data.filter((itemBP) =>
            itemBP.team.some((itemT) => itemT.id == item.team)
          );
          if (idBoPhanForTeam.length != 0) {
            return {
              idTeam: item.team,
              team: item.team__tenTeam,
              idBoPhan: idBoPhanForTeam[0].id,
            };
          }
          return false;
        })
        .filter((item) => item != false);
      const uniqueArrTeam = [
        ...new Map(arrTeam.map((item) => [item["idTeam"], item])).values(),
      ];
      uniqueArrTeam.sort(function (first, second) {
        return first["idTeam"] - second["idTeam"];
      });
      const arrIdTeam = uniqueArrTeam.map((item) => item.idTeam);
      const arrBoPhan = res.data.filter(({ team }) =>
        team.some((item) => arrIdTeam.includes(item.id))
      );
      // const arrBoPhan = res.data.filter(itemBP => itemBP.team.map(item=>item.id).filter(x => arrIdTeam.includes(x)))
      if (arrBoPhan.length > 0) {
        setCurrentBoPhan([arrBoPhan[0].id]);
      }
      setLsBoPhan(arrBoPhan);

      setLsAllTeam(uniqueArrTeam);
      const arrIdTeamInBoPhan_0 = arrBoPhan[0].team.map((item) => item.id);
      if (currentTeam.length === 0) {
        setCurrentTeam([
          arrIdTeam.filter((x) => arrIdTeamInBoPhan_0.includes(x))[0],
        ]); // 200423 lấy element đầu tiên đặt trong list
      }
      setLsTeam(
        uniqueArrTeam.filter((x) => arrIdTeamInBoPhan_0.includes(x.idTeam))
      );

      // DS toàn bộ user của các team
      ListMemberOfTeamApi({
        idTeam: JSON.stringify(uniqueArrTeam.map((item) => item.idTeam)),
      }).then((res) => {
        setLsMemberAll(res.data);
        setLsMember(
          res.data.filter((x) => arrIdTeamInBoPhan_0.includes(x.teamId))
        );
        // setLoading(false);
      });
    });
  };

  useEffect(() => {
    if (
      userInfo &&
      userInfo.team_permissions &&
      userInfo.team_permissions.length > 0
    ) {
      fetchListTeam();
    }
  }, [userInfo]);

  const updateData = () => {
    fetchData({
      idTeam: JSON.stringify(currentTeam),
      thoiGian: moment(currentSelectedDate).format("YYYYMM"),
      ...pager,
    });
  };

  const onChangeBoPhan = (value) => {
    if (value.length > 0) {
      setCurrentBoPhan(value);
      const lsTeamWith_BP = lsAllTeam.filter((x) => value.includes(x.idBoPhan));
      setLsTeam(lsTeamWith_BP);
      setCurrentTeam([lsTeamWith_BP.map((item) => item.idTeam)[0]]); // 200423
    } else {
      setLsTeam([]);
      setCurrentBoPhan([]);
      setCurrentTeam([]);
    }
  };

  const tPropsConfig_BoPhan = {
    treeData: [
      {
        title:
          currentBoPhan.length > 0 ? (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan([]);
                }
              }}
              className="style_SelectTeam"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan(lsBoPhan.map((item) => item.id));
                }
              }}
              className="style_SelectTeam"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeDataBoPhan,
    ],
    value: treeDataBoPhan.length > 0 ? currentBoPhan : undefined,
    onChange: onChangeBoPhan,
    treeCheckable: true,
    // showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 2,
    placeholder: "Chọn bộ phận",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loading,
  };

  useEffect(() => {
    const treeDataBoPhan = lsBoPhan.map((item) => {
      return { title: item.tenBophan, value: item.id, key: item.id };
    });
    setTreeDataBoPhan(treeDataBoPhan);
    if (currentBoPhan.length === 0) {
      setCurrentBoPhan(lsBoPhan.map((item) => item.id));
    }
  }, [lsBoPhan]);

  const onChangeTeam = (value) => {
    if (loading) {
      return;
    }
    if (value.length > 0) {
      setCurrentTeam(value);
    } else {
      setCurrentTeam([]);
      setData([]);
    }
  };

  const tPropsConfig = {
    treeData: [
      {
        title:
          currentTeam.length > 0 ? (
            <span
              onClick={() => {
                setCurrentTeam([]);
                onChangeTeam([]);
              }}
              className="style_SelectTeam"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                setCurrentTeam(lsTeam.map((item) => item.idTeam));
                onChangeTeam(lsTeam.map((item) => item.idTeam));
              }}
              className="style_SelectTeam"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeData,
    ],
    value: treeData.length > 0 ? currentTeam : undefined,
    onChange: onChangeTeam,
    treeCheckable: true,
    // showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 2,
    placeholder: "Chọn team",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loading,
  };

  useEffect(() => {
    const treeDataTemp = lsTeam.map((item) => {
      return { title: item.team, value: item.idTeam, key: item.idTeam };
    });
    setTreeData(treeDataTemp);
    // setCurrentTeam(lsTeam.map(item=>item.idTeam));
    // if (currentTeam.length === 0){
    //     setCurrentTeam(lsTeam.map(item=>item.idTeam));
    // };
  }, [lsTeam]);

  // const getDateRange = (date) =>{
  //     const current = date._d.getDay() === 0 ? 7 : date._d.getDay();
  //     const firstDay = new Date(new Date(date).getTime()-((current-1)*24*60*60*1000));
  //     const endDay = new Date(new Date(firstDay).getTime()+(6*24*60*60*1000));
  //     return getDaysArray(firstDay, endDay);
  // };

  const onChangeMonth = (date) => {
    setCurrentSelectedDate(date);
    // fetchData({
    //     date:date,
    //     idTeam:JSON.stringify(currentTeam),
    //     thoiGian:moment(date).format("YYYYMM"),
    //     ...pager
    // })
  };

  // const onQuickChangeWeek=(type)=>{
  //     const numberDay = type === 'previous' ? -7 : 7;
  //     const newFirstDate = new Date(new Date(lsDate[0]).getTime()+((numberDay)*24*60*60*1000));
  //     const lsDateTemp = getDateRange(moment(newFirstDate));
  //     setCurrentSelectedDate(moment(newFirstDate));
  //     setLsDate(lsDateTemp);
  //     fetchData({idTeam:JSON.stringify(currentTeam),thoiGian:moment(new Date(currentSelectedDate)).format("YYYYMM")})
  // }
  const onQuickChangeMonth = (type) => {
    let monthChange;
    if (type === "previous") {
      monthChange = moment(currentSelectedDate).subtract(1, "month");
    } else {
      monthChange = moment(currentSelectedDate).add(1, "month");
    }
    setCurrentSelectedDate(monthChange);
    // fetchData({
    //     date:monthChange ,
    //     idTeam:JSON.stringify(currentTeam),
    //     thoiGian:moment(monthChange).format("YYYYMM"),
    //     ...pager
    // })
  };

  const handleChange = (pagination) => {
    const currentPager = { ...pager };
    currentPager.current = pagination.current;
    currentPager.pageSize = pagination.pageSize;
    setPager({ ...currentPager });
    fetchData({
      idTeam: JSON.stringify(currentTeam),
      thoiGian: moment(currentSelectedDate).format("YYYYMM"),
      status: currentPager.status,
      pageSize: pagination.pageSize,
      current: pagination.current,
      search,
    });
  };

  const onDuyetPhep = () => {
    duyetPhepTeamApi({
      idTeam: JSON.stringify(currentTeam),
      thoiGian: moment(currentSelectedDate).format("YYYYMM"),
    })
      .then((r) => {
        openNotificationWithIcon(
          "success",
          "Thành công",
          "Duyệt phép thành công."
        );
        updateData();
      })
      .catch((err) => {
        errorHandle(err);
      });
  };

  const onKhaiBaoPhep = () => {
    setIsShowKhaiBaoPhep(true);
  };

  const fileDownloadResult = () => {
    setLoading(true);

    let filename
    if (typeExport === "month") {
      filename = "Bang_Phep_Thang_" + moment(currentSelectedDate).format("YYYYMM") + ".xlsx";
    } else {
      filename = "Bang_Phep_Nam_" + moment(currentSelectedDate).format("YYYY") + ".xlsx";
    }

    ResultLeaveDaysApi({
      idTeam: JSON.stringify(currentTeam),
      thoiGian: moment(currentSelectedDate).format("YYYYMM"),
      type_export: typeExport === "year" ? typeExport : undefined
    })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.ms-excel",
        });
        fnFileDownload(blob, filename);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        openNotificationWithIcon(
          "error",
          "Không tải được danh sách. Bạn vui lòng thử lại."
        );
        setLoading(false);
      });
  };

  const confirm = e => {
    console.log(e);
    fileDownloadResult()
    // message.success('Click on Yes');
  };
  const cancel = e => {
    console.log(e);
    // message.error('Click on No');
  };

  const onChangeTypeExport = (e) => {
    setTypeExport(e.target.value)
  }

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">Bảng phép</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link href="#">Nhân sự</Link>
                </li>
                <li className="breadcrumb-item active">Bảng phép</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div
          className={
            "col-12 mb-2 d-sm-flex align-items-center justify-content-between"
          }
        >
          <div className={"col"}>
            <Button
              type="primary"
              className={"m-2 styleNtn_1"}
              onClick={() => onQuickChangeMonth("previous")}
              title="Tuần trước"
            >
              <i className={"fa fa-arrow-left"}></i>
            </Button>
            {new Date(currentSelectedDate).getTime() <
              new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                1
              ).getTime() && (
                <Button
                  type="primary"
                  className={"m-2 styleNtn_1"}
                  onClick={() => onQuickChangeMonth("next")}
                  title="Tháng sau"
                >
                  <i className={"fa fa-arrow-right"}></i>
                </Button>
              )}
            <DatePicker
              style={{ borderRadius: 10 }}
              className={"m-2"}
              onChange={onChangeMonth}
              picker={"month"}
              value={currentSelectedDate}
              format={"MM/YYYY"}
              disabled={loading}
              allowClear={false}
              disabledDate={disabledMonth}
            />

            <div className="styleBadge">
              <Badge.Ribbon
                text="Bộ phận"
                color="gray"
                style={{ color: "red" }}
              >
                <TreeSelect {...tPropsConfig_BoPhan} />
              </Badge.Ribbon>
            </div>
            <div className="styleBadge">
              <Badge.Ribbon text="Team" color="gray" style={{ color: "red" }}>
                <TreeSelect {...tPropsConfig} />
              </Badge.Ribbon>
            </div>
            <Popconfirm
              title={
                <Radio.Group
                  onChange={onChangeTypeExport}
                  value={typeExport}
                  options={[
                    {
                      value: "month",
                      label: (
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                          Tải theo tháng
                        </div>
                      ),
                    },
                    {
                      value: "year",
                      label: (
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                          Tải theo năm
                        </div>
                      ),
                    }
                  ]}
                />
              }
              // description="Are you sure to delete this task?"
              icon={false}
              onConfirm={confirm}
              onCancel={cancel}
              okText="Đồng ý"
              cancelText="Hủy bỏ"
            >
              <Button
                type="success"
                className={"m-2"}
                // onClick={fileDownloadResult}
                icon={<DownloadOutlined />}
              >
                Tải bảng phép
              </Button>
            </Popconfirm>

          </div>
          <div>
            {new Date(currentSelectedDate).getTime() <
              new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                1
              ).getTime() && (
                <Button type="primary" className={"m-2"} onClick={onDuyetPhep}>
                  Duyệt phép
                </Button>
              )}
            <Button type="info" className={"m-2"} onClick={onKhaiBaoPhep}>
              Khai báo phép
            </Button>
          </div>
        </div>
      </div>
      <div className="row">
        <Table
          dataSource={data}
          columns={columnFinal}
          loading={loading}
          className={"custom-table-hover style-6"}
          bordered={true}
          size={"small"}
          rowKey="id"
          scroll={data.length > 0 && {x:1920,y:500}}
          // scroll={{ y: 500 }}
          onChange={handleChange}
          pagination={{
            current: pager.current,
            pageSize: pager.pageSize,
            total: pager.count,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["50", "75", "100"],
          }}
        // onRow={(record, rowIndex) => {
        //     return {
        //       onClick: event => {
        //         console.log(record);
        //         console.log(rowIndex);
        //       }, // click row
        //       onDoubleClick: event => {}, // double click row
        //       onContextMenu: event => {}, // right button click row
        //       onMouseEnter: event => {}, // mouse enter row
        //       onMouseLeave: event => {}, // mouse leave row
        //     };
        //   }}
        // pagination={false}
        />
        <ModalEditPhep
          visible={isShowEditPhep}
          onCancel={() => setIsShowEditPhep(false)}
          updateData={updateData}
          dataDetailPhep={dataDetailPhep}
        />
        <ModalKhaiBaoPhep
          visible={isShowKhaiBaoPhep}
          onCancel={() => setIsShowKhaiBaoPhep(false)}
          updateData={updateData}
          currentSelectedDate={currentSelectedDate}
          lsMember={lsMember}
        />
        {/* <ModalEditPhepNam
                    visible={isShowEditPhepNam}
                    onCancel={()=>setIsShowEditPhepNam(false)}
                    updateData={updateData}
                    currentSelectedDate={currentSelectedDate}
                    dataDetailPhep={dataDetailPhep}
                    lsMember={lsMember}
                /> */}
      </div>
    </>
  );
};
